import type {BreakpointID} from '@packages/systems/style/types';
import {
  BREAKPOINT_ID_LARGE,
  BREAKPOINT_ID_MAIN,
  BREAKPOINT_ID_MEDIUM,
  BREAKPOINT_ID_SMALL,
  BREAKPOINT_ID_TINY,
  BREAKPOINT_ID_XL,
  BREAKPOINT_ID_XXL,
} from '@packages/systems/style/breakpoint-ids';

/**
 * Order of breakpoints rendered side-by-side.
 */
export const MCC_RENDER_ORDER: BreakpointID[] = [
  BREAKPOINT_ID_XXL,
  BREAKPOINT_ID_XL,
  BREAKPOINT_ID_LARGE,
  BREAKPOINT_ID_MAIN,
  BREAKPOINT_ID_MEDIUM,
  BREAKPOINT_ID_SMALL,
  BREAKPOINT_ID_TINY,
];

export const mccFrameIdFor = (breakpointId: BreakpointID): string =>
  `frame-${breakpointId}`;
